<div class="ticket-summary-item" fxLayout="column" fxLayoutGap="20px">
  <!-- ticket-summary-item-header begin -->
  <div
    class="ticket-summary-item-header"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutGap="15px"
    fxFlex="100"
    fxLayoutGap.lt-md="0px"
  >
    <!--  EVent Image      -->
    <btx-event-image
      [count]="ticketCount"
      [imageSrc]="firstTicketItem.eventImage | secureImage"
    >
    </btx-event-image>

    <!--        -->
    <div class="product-detail" fxLayout="column" fxFill>
      <!--            -->
      <btx-sub-title
        class="event-name-title"
        [title]="firstTicketItem.eventName | shorten : 40"
        [matTooltip]="
          firstTicketItem.eventName.length > 40 ? firstTicketItem.eventName : ''
        "
        [routerLink]="[performancePageLink]"
      ></btx-sub-title>

      <!--            -->
      <btx-event-description
        [venueName]="firstTicketItem?.venueName"
        [venueCity]="firstTicketItem?.venueCity"
        [liveEvent]="isLiveEvent()"
        [startDate]="firstTicketItem?.performanceDate"
      ></btx-event-description>

      <!--            -->
      <div
        class="product-detail-row product-action-buttons"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div class="event-rules action-buttons" *ngIf="!getIsMobile()">
          <button
            class="event-rules"
            mat-flat-button
            (click)="showEventRules()"
            *ngIf="isEventRulesVisible()"
          >
            <mat-icon aria-hidden="false">rule</mat-icon>
            {{ "shared.labels.eventRules" | translate }}
          </button>
        </div>
        <div class="total-price-detail" fxLayoutAlign="end">
          <btx-product-price
            [value]="getShoppingItemsTotalPrice()"
          ></btx-product-price>

          <!--                -->
          <div class="service-fee" *ngIf="!hasZeroPrice()">
            <span class="service-fee-title"
              >{{ "shared.labels.serviceFee" | translate }}:</span
            >
            <btx-product-price
              class="service-fee-price"
              [value]="getShoppingItemsTotalServicePrice()"
            >
            </btx-product-price>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ticket-summary-item-header end -->

  <!-- ticket-summary-item-content begin -->
  <div class="ticket-summary-item-content" fxLayout="column" fxLayoutGap="15px">
    <!--   Upsell List    begin -->
    <div class="event-upsell-list-wrapper" *ngIf="isEventUpsellVisible()">
      <h2>
        {{
          "cart.labels.takenTogetherMobile"
            | translate : { value: totalUpsellCount }
        }}
      </h2>
      <div class="event-upsell-list">
        <!--   Upsell Item begin  -->
        <div class="event-upsell-item" *ngFor="let upsellItem of eventUpsells">
          <!--  upsell image and quantity begin   -->
          <div class="upsell-image-container">
            <img
              [src]="upsellItem.upsellImage | secureImage : upsellImageBasePath"
              class="upsell-thumb"
              alt=""
            />

            <span
              class="upsell-quantity"
              matBadgeColor="warn"
              [matBadge]="'x' + upsellItem.quantity"
            ></span>
          </div>
          <!-- upsell image and quantity end  -->
          <div class="upsell-item-right">
            <h3>{{ upsellItem.upsellName }}</h3>
            <span class="upsell-price">{{
              upsellItem.upsellTotalPrice | customCurrency
            }}</span>
            <div
              class="upsell-token-container"
              *ngFor="let upseltkn of upsellItem.distributionTokens"
            >
              <div class="upsell-token-container">
                <span class="upsell-price upsell-token">{{ upseltkn }}</span>
                <!-- <span class="upsell-price upsell-token">KJFKF98494</span>
								<span class="upsell-price upsell-token">KJFKF98494</span> -->
              </div>
            </div>
          </div>
        </div>
        <!--   Upsell Item end  -->
      </div>
    </div>
    <!--   Upsell List    end -->

    <!--      Seat Number List     begin -->
    <div class="seat-number-list-wrapper">
      <!--            -->
      <h2 class="title">
        {{ "shared.labels.seatInfos" | translate : { count: ticketCount } }}
      </h2>

      <!--            -->
      <ol class="seat-number-list" fxLayout="row wrap" fxLayoutGap="20px grid">
        <li
          class="seat-number-item"
          fxFlex="25%"
          fxFlex.lt-md="33%"
          fxFlex.lt-sm="50%"
          *ngFor="let seatItem of seatNumberList"
        >
          <h2 class="sub-title">{{ seatItem.title | titlecase }}</h2>

          <!--                    -->
          <div class="seat-section">
            <span class="text-label"
              >{{ "shared.labels.section" | translate }}:
            </span>
            <span>{{ seatItem.section }}</span>
          </div>

          <!--                    -->
          <div class="seat-row-no" *ngIf="!isLiveEvent()">
            <span class="text-label"
              >{{ "shared.labels.row" | translate }}/{{
                "shared.labels.seat" | translate
              }}:
            </span>
            <span>{{ seatItem.rowNo }}</span>
          </div>
        </li>
      </ol>
    </div>

    <div class="onlineEvent" fxLayout="column" fxLayoutGap="10px" *ngIf="hasLiveToken() && showLiveEventContainer">
      <span *ngFor="let token of liveEventTokens">{{ "account.labels.onlineCode" | translate }}:
        <span>{{ token }}</span>
      </span>
    </div>

<!--    <div class="onlineEvent" fxLayout="column" fxLayoutGap="10px" *ngIf="hasLiveEventLink()">-->
<!--      <span *ngFor="let link of liveEventDistributionLink">{{ "account.labels.onlineLink" | translate }}:-->
<!--        <span>{{ link }}</span>-->
<!--      </span>-->
<!--    </div>-->

    <div class="onlineLink"  fxLayout="column" fxLayoutGap="10px" *ngIf="hasLiveEventLink() && showLiveEventContainer">
      <span>{{ firstTicketItem.ticketNote }}</span>
      <a
      [href]="liveEventDistributionLink"
      target="_blank"
      class="view-ticket-button"
      fxLayout="row" fxLayoutGap="5px"
    >
      <mat-icon>receipt_long</mat-icon>
      <span>{{ "account.labels.onlineLink" | translate }}</span>
    </a>
    </div>



    <!--        -->
    <div class="ticket-summary-actions" *ngIf="isLinksVisible()">
      <!--            -->
      <mat-icon class="view-ticket-icon">subdirectory_arrow_right</mat-icon>

      <!--     Fatura     -->
      <a [href]="invoiceLink" target="_blank" class="view-ticket-button">
        <mat-icon>insert_drive_file</mat-icon>
        <span>{{ "shared.labels.viewInvoice" | translate }}</span>
      </a>

      <!--       PDF Link     -->
      <a
        [href]="digitalTicketLink"
        target="_blank"
        *ngIf="isHomePrint && !isLiveEvent()"
        class="view-ticket-button"
      >
        <mat-icon>receipt_long</mat-icon>
        <span>{{ "shared.labels.seeDigitalTicket" | translate }}</span>
      </a>
    </div>

    <span *ngIf="firstTicketItem?.navigateUrlLink">
      Etkinlik alanında 45 dk önce hazır bulunulması gerekmektedir. Bilet alma işlemini tamamladıktan sonra aşağıda yer
      alan
      <a
        [href]="firstTicketItem.navigateUrlLink"
        target="_blank"
        class="view-ticket-button"
      >
        <span>{{ '"Buz Adası Etkinlik Kayıt Formu"' }}</span>
      </a>
      linkine tıklayıp muvakafakatnameyi doldurmamız. Zeytinburnu Buz Adası'na
      geldiğinizde bekleme sürenizi azaltacaktır.Kayıt formunun bireysel
      doldurulması gerekmektedir. 7-18 yaşındakiler velileri ile (yalnızca anne veya baba) birlikte Zeytinburnu Buz Adası pistlerinden faydalanabilir.
    </span>
  </div>

  <mat-divider *ngIf="!isLast"></mat-divider>
</div>
